import React from "react";
import { PaymentInfoToast } from "components/PaymentInfoToast/PaymentInfoToast";
import { SubmitButton } from "components/SubmitButton";
import { CalendarTick } from "components/icons/components/CalendarTick";
import { CAMPAIGN_INTERNAL_STATUSES } from "pages/constants";
import { BookingModal } from "../../BookingModal/BookingModal";
import { SubmitAndPayButton } from "./SubmitAndPayButton";
import { TermsAgreementNote } from "campaign-builder/checkout/TermsAgreementNote";

interface SubmitCampaignFooterProps {
  internalStatus: keyof typeof CAMPAIGN_INTERNAL_STATUSES;
  loading: boolean;
  startDateError: boolean;
  billingBlocked?: boolean;
  flyerInfo?: { s3Link?: string };
  isPaymentSkipped: boolean;
  handleClickSubmitAndPay: () => void;
  isNotDesign: boolean;
  isBookingModalOpen: boolean;
  onBookReviewMeeting: () => void;
  onCloseBookingModal: () => void;
  submitter: {
    firstName: string;
    lastName: string;
    email: string;
  };
  country?: {
    code: string;
    name?: string;
  };
  type: "primary" | "secondary";
  onScheduleSuccess: (reviewMeetingDate: string) => void;
  campaignCost?: number;
  channel?: string;
  campaignId?: string;
  companyName?: string;
  userId?: string;
}

export const SubmitCampaignFooter = ({
  internalStatus,
  loading,
  startDateError,
  billingBlocked,
  flyerInfo,
  isPaymentSkipped,
  handleClickSubmitAndPay,
  isNotDesign,
  isBookingModalOpen,
  onBookReviewMeeting,
  onCloseBookingModal,
  submitter,
  country,
  onScheduleSuccess,
  campaignCost,
  channel,
  campaignId,
  companyName,
  userId,
}: SubmitCampaignFooterProps) => {
  const submitAndPayButton = (
    <SubmitAndPayButton
      internalStatus={internalStatus}
      disabled={loading || startDateError || !flyerInfo?.s3Link || billingBlocked}
      loading={loading}
      isPaymentSkipped={isPaymentSkipped}
      handleClickSubmitAndPay={handleClickSubmitAndPay}
      isNotDesign={isNotDesign}
      type="primary"
    />
  );

  return (
    <>
      <div className="justify-content mb-0 flex flex-col" data-cy="submitAndPayBtn">
        <PaymentInfoToast />
        <div className="justify-content flex justify-end gap-2 max-md:flex-col">
          <SubmitButton onClick={onBookReviewMeeting} type="secondary" icon={<CalendarTick />}>
            Book a review meeting
          </SubmitButton>
          {submitAndPayButton}
        </div>
        {/* Same 24px gap the payment banner leaves above the buttons. */}
        <TermsAgreementNote
          actionLabel={isPaymentSkipped ? "Submit" : "Submit and Pay"}
          className="mt-6 text-right max-md:text-left"
        />
      </div>

      <BookingModal
        isOpen={isBookingModalOpen}
        onClose={onCloseBookingModal}
        title="Book a review meeting"
        submitter={submitter}
        country={country}
        onScheduleSuccess={onScheduleSuccess}
        campaignCost={campaignCost}
        channel={channel}
        campaignId={campaignId}
        companyName={companyName}
        userId={userId}
      />
    </>
  );
};
